export default __webpack_public_path__ + "static/media/books-29.3a950157.jpg";